module.exports = __WEBPACK_EXTERNAL_MODULE_11__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Rx","commonjs":"rxjs/BehaviorSubject","commonjs2":"rxjs/BehaviorSubject","amd":"rxjs/BehaviorSubject"}
// module id = 11
// module chunks = 0 1